import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import ArticleDetail from '@/views/ArticleDetail.vue'
import CategoryPage from '@/views/CategoryPage.vue'
import SearchPage from '@/views/SearchPage.vue'
import FeedbackPage from '@/views/FeedbackPage.vue'
import NotFound from '@/views/NotFound.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'home', component: HomePage },
    { path: '/article/:id', name: 'article', component: ArticleDetail },
    { path: '/category/:slug', name: 'category', component: CategoryPage },
    { path: '/search', name: 'search', component: SearchPage },
    { path: '/feedback', name: 'feedback', component: FeedbackPage },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFound },
  ],
  scrollBehavior() {
    return { top: 0 }
  },
})

export default router
